"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LLM_MARKING_PROMPT_IDS = exports.QuestionDifficulty = exports.QuestionType = exports.AutoMarkType = void 0;
var AutoMarkType;
(function (AutoMarkType) {
    AutoMarkType["NONE"] = "none";
    AutoMarkType["CLASSIFICATION"] = "classification";
    AutoMarkType["DISTANCE"] = "distance";
    AutoMarkType["LLM"] = "llm";
})(AutoMarkType = exports.AutoMarkType || (exports.AutoMarkType = {}));
var QuestionType;
(function (QuestionType) {
    QuestionType["SIMPLE"] = "simple";
    QuestionType["MULTI_REASON"] = "multi-reason";
    QuestionType["MULTI_MODEL"] = "multi-model";
    QuestionType["CALCULATION"] = "calculation";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var QuestionDifficulty;
(function (QuestionDifficulty) {
    QuestionDifficulty["HARD"] = "hard";
})(QuestionDifficulty = exports.QuestionDifficulty || (exports.QuestionDifficulty = {}));
exports.LLM_MARKING_PROMPT_IDS = [
    'aqa-gcse-english-language-paper1-question1',
    'aqa-gcse-english-language-paper1-question2',
    'aqa-gcse-english-language-paper1-question3',
    'aqa-gcse-english-language-paper2-question2',
    'aqa-gcse-biology-6-marks',
    'aqa-gcse-chemistry-6-marks',
    'aqa-gcse-physics-6-marks'
];
//# sourceMappingURL=question.js.map